import type { Auth0ConnectorHosting } from "@p0security/integrations-auth0-shared/types";

/** A connector image on Docker Hub, pinned by the digest its tag resolves
 * to. */
export type ConnectorImage = Readonly<{
  /** `sha256:<digest>` */
  digest: string;
  name: string;
  tag: string;
}>;

/** The connector build each cloud deploys: one image for AWS Lambda and one
 * for Cloud Run, built from the same service.
 *
 * Each is a p0-security-perimeter build of the connector, by its
 * `sha-<commit>` tag on Docker Hub and the digest that tag resolves to
 * (`docker buildx imagetools inspect <name>:<tag>`). The service's source has
 * moved to `submodules/connector`, but these pins still name perimeter builds
 * until they're moved to that repo's images. */
export const CONNECTOR_IMAGES: Readonly<
  Record<Auth0ConnectorHosting["type"], ConnectorImage>
> = {
  aws: {
    digest:
      "sha256:db2cf719e85eb524e02a3040a8c1effd32247b3c576f9706dd43d18a41ce2841",
    name: "p0security/p0-connector-auth0",
    tag: "sha-6185e9d",
  },
  gcp: {
    digest:
      "sha256:4ebbdd4b7b77050b6274b9978d588fbec8e7b597dd0b5861310d64b23cfe1922",
    name: "p0security/p0-connector-auth0-gcloud",
    tag: "sha-6185e9d",
  },
};
